import { API_JWT_BASE_URL } from '../http'

export const SEARCH_FACTORYSETTINGS_API = `${API_JWT_BASE_URL}/configuration/factorysettings/search`
export const CREATE_FACTORYSETTING_API = `${API_JWT_BASE_URL}/configuration/factorysettings`
export const UPDATE_FACTORYSETTING_API = `${API_JWT_BASE_URL}/configuration/factorysettings/`
export const DELETE_FACTORYSETTINGS_API = `${API_JWT_BASE_URL}/configuration/factorysettings/`
export const GET_FACTORYSETTINGS_DETAIL_API = `${API_JWT_BASE_URL}/configuration/factorysettings/details/`
export const GET_GROUPLISTBYDEVICEFORMATIONID_API = `${API_JWT_BASE_URL}/configuration/factorysettings/search/groups/`

export const FACTORYSETTINGS_QUERY_KEYS = {
  SEARCH_FACTORYSETTINGS: 'searchTaitFactorySettings',
  CREATE_FACTORYSETTING: 'createTaitFactorySetting',
  UPDATE_FACTORYSETTING: 'updateTaitFactorySetting',
  DELETE_FACTORYSETTINGS: 'deleteTaitFactorySettings',
  GET_FACTORYSETTING_DETAIL: 'detailTaitFactorySetting',
  GET_GROUPLISTBYDEVICEFORMATIONID: 'getGroupListByDeviceFormationId',
}
